import { render, staticRenderFns } from "./PriceWorkflowStyleSelect.vue?vue&type=template&id=08c4e8c4&scoped=true&"
import script from "./PriceWorkflowStyleSelect.vue?vue&type=script&lang=js&"
export * from "./PriceWorkflowStyleSelect.vue?vue&type=script&lang=js&"
import style0 from "./PriceWorkflowStyleSelect.vue?vue&type=style&index=0&id=08c4e8c4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c4e8c4",
  null
  
)

export default component.exports